import { DEFAULT_LANGUAGE } from 'constants/localization';

export const getLanguage = (): string => {
    const language = window?.localStorage?.getItem('language');

    return language ? language : DEFAULT_LANGUAGE;
};
